import StatusError from './StatusError';

export default class Status404Error extends StatusError {}
